// extracted by mini-css-extract-plugin
export default {"comments":"Tab_comments__tJaPQ"};